import { Fragment, FunctionalComponent, h } from 'preact';
import { WithStyles, withStyles } from '../../../../style';
import { ProfileTier } from '../../../../interfaces';
import * as styles from './AwardContent.scss';
import { FlightContent } from '../FlightContent';
import { AwardInformation } from './AwardInformation';
import { AwardContentProps } from './interfaces/interface';

type AwardRenderProps = AwardContentProps & WithStyles;

export const AwardContent: FunctionalComponent<AwardContentProps> = withStyles(styles)(
  ({ profile, navigateToJoin, navigateToLogin, isOneWay, setFocusElement, testVariant }: AwardRenderProps) => {
    const showAwardCorporateView = profile.isLoggedIn && profile.tier === ProfileTier.CORPORATE;
    const showAwardUpgradeView = profile.isLoggedIn && profile.tier === ProfileTier.ACCOUNT;
    const showAwardBookingView =
      profile.isLoggedIn && profile.tier !== ProfileTier.ACCOUNT && profile.tier !== ProfileTier.CORPORATE;
    return (
      <Fragment>
        {showAwardBookingView && (
          <FlightContent testVariant={testVariant} isOneWay={isOneWay} setFocusElement={setFocusElement} isAward />
        )}
        {!showAwardBookingView && (
          <AwardInformation
            navigateToLogin={navigateToLogin}
            navigateToJoin={navigateToJoin}
            isUpgradeView={showAwardUpgradeView}
            isCorporateView={showAwardCorporateView}
          />
        )}
      </Fragment>
    );
  }
);
